module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-3-photo-11-523f5b1e3a881f10655089bf242c4003.webp";